import { Amplify } from "aws-amplify";
import { clientId, hostedDomain, userPoolId } from "config";
import { createContext, type ReactNode, useContext } from "react";
import { useCognitoAuthState } from "./hooks";

let isAuthConfigured = false;

export function configureAuth() {
  if (isAuthConfigured) return;

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId: clientId,
        loginWith: {
          oauth: {
            domain: hostedDomain,
            redirectSignIn: [window.location.origin + "/"],
            redirectSignOut: [window.location.origin + "/"],
            scopes: [
              "openid",
              "email",
              "profile",
              "urn:modelve:core-api/portfolio:read urn:modelve:core-api/portfolio:write urn:modelve:core-api/profile:read urn:modelve:core-api/profile:write urn:modelve:core-api/tenant:billing urn:modelve:core-api/tenant:write",
              "aws.cognito.signin.user.admin",
            ],
            responseType: "code",
          },
        },
      },
    },
  });
  isAuthConfigured = true;
}

const AuthProvider = ({ children }: { children: ReactNode }) => {
  return <CognitoContextProvider>{children}</CognitoContextProvider>;
};

export default AuthProvider;

const CognitoContextProvider = ({ children }: { children: ReactNode }) => {
  const state = useCognitoAuthState();
  return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
};

export interface AuthUser {
  sub: string;
  email: string;
}

export interface AuthContextState {
  user: AuthUser | undefined;
  isLoading: boolean;
  login: () => Promise<void>;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextState | undefined>(undefined);

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
};
